<template>
  <div class="home-main common-font-size">
    <div class="header">
      <div>
        <span style="font-size: 18px; font-weight: 600;">工序任务</span>
        <span class="left-default-margin cursor-pointer">
          <i class="el-icon-setting"></i>
          <span class="common-small-size">设置</span>
        </span>
        <span class="left-default-margin">
          <el-checkbox v-model="onlyRun" @change="onlyRunChange">包含未开始生产任务</el-checkbox>
        </span>
      </div>
      <div class="header-right">
        <span class="cursor-pointer">
          <i class="el-icon-refresh-right"></i>
          <span class="common-small-size" @click="onlyRunChange">刷新</span>
        </span>
        <el-radio-group v-model="tabPosition" size="mini" class="left-default-margin">
          <el-radio-button label="今天">今天</el-radio-button>
          <el-radio-button label="昨天">昨天</el-radio-button>
          <el-radio-button label="本月">本月</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div style="background: #fff;padding: 16px;overflow-y: auto;max-height: 320px;margin-bottom: 15px;">
      <div class="card-box" v-for="(item, index) in processTasks" :key="index" v-if="processTasks && processTasks.length!=0">
        <div class="card-body" @click="showDialog(item)">
          <div class="card-body-header">
            <div class="display-flex">
              <div class="header-left" :style="{background:item.color}">{{item.processName}}</div>
              <div class="header-right" :style="{background:item.color}"></div>
            </div>
          </div>
          <div class="card-body-left">
            <div class="body-left-top">{{item.taskNum}}</div>
            <div class="body-left-bottom">生产任务数</div>
          </div>
          <div class="card-body-right">
              <div class="body-right-common">
                <div class="right-common-left">计划数</div>
                <div class="right-one-right right-common-right">{{item.planNum}}</div>
              </div>
              <div class="body-right-common">
                <div class="right-common-left">良品数</div>
                <div class="right-two-right right-common-right">{{item.goodNum}}</div>
              </div>
              <div class="body-right-common">
                <div class="right-common-left">不良品数</div>
                <div class="right-three-right right-common-right">{{item.nongoodNum}}</div>
              </div>
          </div>
        </div>
        <div class="progress-box">
          <div class="progress-content">
            <span class="title">进度</span>
            <div class="progress">
              <el-progress :percentage="item.progress?Number(item.progress):0"></el-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="display-flex">
      <div class="home-table">
        <div class="white-background list-top-margin">
          <el-row class="list-top-margin">
            <el-col :span="12" style="line-height: 28px">
              工单进度报表
            </el-col>
            <el-col :span="12" class="text-align-right">
              <el-radio-group v-model="tabRadioPosition" size="mini" class="left-default-margin" @input="filterStatus">
                <el-radio-button :label="item.value" v-for="(item ,index) in radioDataList" :key="index">{{item.label}}</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <!--列表-->
          <el-table
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          height="400px"
          >
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
            <el-table-column  prop="orderCode" label="工单编号" width="180">
            <template slot-scope="scope">
              <span>{{scope.row.orderCode}}</span>
              <!-- <el-tag v-for="(item,index) in scope.row.orderStatus" :type="changeStatusColor(item)" :key="item" style="height:28px;margin-left: 4px;" :style="{'marginBottom':(index!=scope.row.orderStatus.length-1)?'8px':'0'}">{{item}}</el-tag> -->
            </template>
          </el-table-column>
          <el-table-column prop="productCode" label="产品编号" width="150">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="doDetail(scope.row)">{{scope.row.productCode}}</el-button>
              </template>
          </el-table-column>

          <el-table-column prop="productName" label="产品名称" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.productName}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="specs" label="产品规格" width="90">
            <template slot-scope="scope">
                <div>{{scope.row.specs}}</div>
              </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="90">
             <template slot-scope="scope">
              <el-tag :type="changeStatusColor(scope.row.orderStatus)" size="small">{{scope.row.orderStatus}}</el-tag>
                  <!-- <el-tag v-for="(item,index) in scope.row.status" :type="changeStatusColor(item)" :key="item" style="height:28px;" :style="{'marginBottom':(index!=scope.row.status.length-1)?'8px':'0'}">{{item}}</el-tag> -->
              </template>
            <!-- <template slot-scope="scope">
                <el-tooltip :content="scope.row.status" placement="top">
                    <span class="small-cilcle" :class="changeClass(scope.row)"></span>
                    <span class="txt-overflow">{{scope.row.status}}</span>
                </el-tooltip>
              </template> -->
          </el-table-column>
          <el-table-column  prop="produceTasks" label="生产进度" width="400">
            <template slot-scope="scope">
              <div class="list-line-box">
                <div class="default-process-item" v-for="(item,index) in scope.row.produceTasks" :key="item.label">
                  <el-tooltip class="item" effect="dark" placement="right">
                      <div slot="content">
                        <div class="tootip-content">
                          <div style="font-size:14px;font-weight:bold;" class="bottom-small-margin content">{{item.processName}}</div>
                          <div>工序进度：{{item.goodNum?item.goodNum:0}}/{{item.planNum?item.planNum:0}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="content">工序计划数：{{item.planNum}}</div>
                          <div class="content">已报工良品数：{{item.goodNum}}</div>
                          <div>已报工不良品数：{{item.nongoodNum}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="content">已审批良品数：{{item.approvedGoodNum}}</div>
                          <div>未审批良品数：{{item.unapprovedGoodNum}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="bottom-mini-margin content">最近报工时间：{{item.updateTime}}</div>
                        </div>
                      </div>
                      <div>
                        <div style="display: flex; align-items: center;">
                          <div class="default-circle" :class="{'blue-circle':(item.process > 0 && item.process < 100) ,'green-circle':item.process >= 100}">
                            <div class="delay-tag default-delay-tag" v-if="item.exceed">逾</div>
                            <span class="default-percent-text" v-if="item.process < 100">{{item.process}}%</span>
                            <i class="el-icon-check" v-if="item.process >= 100"></i>
                          </div>
                          <span style="position: absolute;left: 48px;color: #bbb;" v-if="index!=(scope.row.produceTasks.length-1)">——</span>
                        </div>
                        <div class="process-text default-process-text">{{item.processName}}</div>
                      </div>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  label="计划开始时间" width="140">
            <template slot-scope="scope">
                <div>{{scope.row.planStartTime && scope.row.planStartTime}}</div>
              </template>
          </el-table-column>
          <el-table-column label="计划结束时间" width="140">
            <template slot-scope="scope">
                <div>{{scope.row.planEndTime && scope.row.planEndTime}}</div>
              </template>
          </el-table-column>
          <el-table-column prop="planNum" label="计划数" width="80"></el-table-column>
          <!-- <el-table-column  label="良品数" width="80"></el-table-column> -->
          <el-table-column prop="remark" label="备注" width="80"></el-table-column>
          <el-table-column prop="creater" label="创建人" width="100"></el-table-column>
          <!-- <el-table-column prop="updater" label="更新人" width="80"></el-table-column> -->
          <el-table-column prop="unit" label="单位" width="80"></el-table-column>
          <el-table-column prop="actualStartTime" label="实际开始时间" width="140"></el-table-column>
          <el-table-column prop="actualEndTime" label="实际结束时间" width="140"></el-table-column>
          <el-table-column align="left" label="操作" width="140" fixed="right">
              <template slot-scope="scope">
                <span class="self-button cursor-pointer" @click="clickDropDown('开始',scope.row)">开始</span>
                <span class="self-button cursor-pointer" @click="clickDropDown('撤回',scope.row)">撤回</span>
                <span class="self-button cursor-pointer" @click="clickDropDown('结束',scope.row)">结束</span>
                <span class="self-button cursor-pointer" @click="clickDropDown('取消',scope.row)">取消</span>
                <!-- <span class="self-button cursor-pointer" @click="clickDropDown('复制',scope.row)">复制</span> -->
                <span class="self-button cursor-pointer" @click="clickDropDown('删除',scope.row)">删除</span>
              </template>
          </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
        </div>
        <div class="white-background">
          <div class="title list-top-margin">常用报表入口</div>
          <el-row class="list-top-margin">
            <el-col :span="4">
              <i class="el-icon-connection" style="vertical-align: middle;color: #409eff;cursor: pointer;"></i>
              <el-link type="primary" :underline="false" @click="navigate(0)">产量统计</el-link>
            </el-col>
            <el-col :span="5">
              <i class="el-icon-connection" style="vertical-align: middle;color: #409eff;cursor: pointer;"></i>
              <el-link type="primary" :underline="false" @click="navigate(1)">员工绩效</el-link>
            </el-col>
            <el-col :span="5">
              <i class="el-icon-connection" style="vertical-align: middle;color: #409eff;cursor: pointer;"></i>
              <el-link type="primary" :underline="false" @click="navigate(2)">工资报表</el-link>
            </el-col>
            <el-col :span="5">
              <i class="el-icon-connection" style="vertical-align: middle;color: #409eff;cursor: pointer;"></i>
              <el-link type="primary" :underline="false" @click="navigate(3)">生产报表</el-link>
            </el-col>
            <el-col :span="5">
              <i class="el-icon-connection" style="vertical-align: middle;color: #409eff;cursor: pointer;"></i>
              <el-link type="primary" :underline="false" @click="navigate(4)">不良品项统计</el-link>
            </el-col>
          </el-row>

        </div>
      </div>
      <div class="right-other">
        <div class="title">绩效指标</div>
        <div class="other-target-box">
          <div class="other-target">
            <div class="other-target-value">{{ kpi.totalPlanNum }}</div>
            <div class="other-target-label">计划数</div>
          </div>
          <div class="other-target">
            <div class="other-target-value" style="color: rgb(2, 185, 128);">{{ kpi.totalGoodNum }}</div>
            <div class="other-target-label">完成数量</div>
          </div>
          <div class="other-target">
            <div class="other-target-value">{{ kpi.orderNum }}</div>
            <div class="other-target-label">工单数量</div>
          </div>
          <div class="other-target">
            <div class="other-target-value"><span style="color: rgb(2, 185, 128);">{{kpi.nongoodRate}}</span>%</div>
            <div class="other-target-label">不良品率</div>
          </div>
          <div class="other-target">
            <div class="other-target-value">{{kpi.avgDay ? kpi.avgDay:0}}天</div>
            <div class="other-target-label">平均工单</div>
            <div class="other-target-label">生产周期</div>
          </div>
          <div class="other-target">
            <div class="other-target-value" style="color: rgb(255, 89, 80);">{{kpi.overtimeAndUncompletedOrder}}</div>
            <div class="other-target-label">超期</div>
            <div class="other-target-label">未完成工单</div>
          </div>
        </div>
        <div>
          <!-- 用报工的接口 -->
          <div class="title" style="margin-top: 12px;">生产实时播报</div>
          <!-- infinite-scroll-distance 触发加载的距离阈值，单位为px -->
          <div class="step-box">
            <el-timeline>
              <el-timeline-item
              placement="top"
                v-for="(activity, index) in activities"
                :key="index"
                icon="el-icon-more"
                type="primary"
                color="#0bbd87"
                size="small"
                :timestamp="activity.updateTime">
                <div>
                  <div>
                    <span>{{activity.baseInfo.producer?activity.baseInfo.producer.name:''}}</span>
                    <span>{{activity.baseInfo.processName}}</span>
                  </div>
                  <div style="color: rgb(155, 155, 155);margin-top: 5px;">
                    <div><span>工单号：</span>{{activity.baseInfo.orderCode}}</div>
                    <div><span>产品信息：</span>{{activity.baseInfo.productCode}}|{{activity.baseInfo.productName}}</div>
                    <div>{{activity.baseInfo.goodNum}} 良品 / <span>{{activity.baseInfo.nongoodNum}} 不良品({{activity.baseInfo.nongoodName}})</span></div>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
            <p v-if="loadingData">加载中...</p>
            <p v-if="noMore">没有更多了</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="生产任务明细报表" :visible.sync="dialogVisible" width="900px" @close="done" :close-on-click-modal="false">
      <ProductionTask v-if="dialogVisible" @done="done" :editRow="editRow"></ProductionTask>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import { getProcessTasks,enterGetList,orderGetList,orderDelete,orderUpdateStatus} from '@/api/basicData'
import Pagination from "@/components/Pagination";
import ProductionTask from "@/views/home/ProductionTask";
export default {
  components:{
    Pagination,
    ProductionTask
  },
  watch:{
    tabPosition:function(val){
      this.getProcessTasks();
    }
  },
  data() {
    return {
      loading:false,
      onlyRun:false,
      tabPosition:'今天',
      tabRadioPosition:'未开始',
      colorArray:['rgb(40, 194, 228)','rgb(116, 130, 229)','rgb(250, 173, 20)','rgb(61, 210, 126)',
      'rgb(0, 185, 190)','rgb(24, 144, 255)','rgb(255, 89, 80)','rgb(228, 191, 83)','rgb(147, 181, 77)','rgb(0, 173, 119)'],//每十个一轮回
      // cartDataList:[{
      //   name:'精车加工',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },{
      //   name:'车轮组装',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },{
      //   name:'攻牙',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },{
      //   name:'电镀',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'车轮调试',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },{
      //   name:'开料',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },{
      //   name:'车架组装',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'包装',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'粗车加工',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // }, {
      //   name:'裁线',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'整车调试',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'买彩票',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'滚齿',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'去毛刺',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'打孔',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'抛光',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'开模',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'粗车加工',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // },
      // {
      //   name:'采购',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // }, {
      //   name:'工序-测试',
      //   productTaskNum:'3',
      //   planNum:'102',
      //   goodProductsNum:'30',
      //   badProductsNum:'15',
      //   progress:30,
      // }
      // ],
      processTasks:[],
      radioDataList:[{
        label:'未开始',
        value:'未开始'
      },{
        label:'执行中',
        value:'执行中'
      },
      // {
      //   label:'三天内到期',
      //   value:'2'
      // },{
      //   label:'超期未完工',
      //   value:'3'
      // },{
      //   label:'本月超期完成',
      //   value:'4'
      // },{
      //   label:'今日完成',
      //   value:'5'
      // },{
      //   label:'本月完成',
      //   value:'6'
      // }
    ],
      listData:[
        // {
        //   deptNo:'1111' ,
        //   orderStatus:['延期'],
        //   status:'执行中',
        //   progress:[{label:'车轮组装',value:0,exceed:false},{label:'车架组装',value:0,exceed:false},{label:'整车调试',value:0,exceed:false}]
        // },
        // {
        //   orderStatus:'',
        //   status:'已结束',
        //   progress:[{label:'车轮组装',value:50,exceed:true},{label:'车轮调试',value:0,exceed:true},{label:'车架组装',value:0,exceed:true},{label:'整车调试',value:0,exceed:true}]
        // }
      ],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      activities: [],
      dialogVisible:false,
      editRow:{},
      userData:JSON.parse(window.localStorage.getItem('userdata')),
      loadingData: false,
      noMore: false, // 控制滚动禁用
      routeLoad: false, // 控制滚动禁用
      pageNo: 1, // 页码
      pageSize: 20, // 一页6条
      orderStayus:'未开始',
      kpi:{}
    }
  },
  created() {
    this.getProcessTasks()
    this.enterGetList();
    this.getdata()
    this.timer = setInterval(() => {
      this.enterGetList();
      this.getProcessTasks();
    }, 10000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    navigate(type){
      var url = "";
      switch(type){
        case 0:url = "/home/report/FinishedProduction";break;
        case 1:url = "/home/report/StaffWorkMonth";break;
        case 2:url = "/home/report/StaffWork";break;
        case 3:url = "/home/report/FinishedProductionMonth";break;
        case 4:url = "/home/report/NoGoodDistributionMonth";break;
      }
      this.$router.push({path:url});
    },
    onlyRunChange(){
      this.getProcessTasks()
    },
    // 查询工单进度报表
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          orderStatus:this.orderStayus
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      params.condition[this.searchSelectValue] = this.searchInputValue
      orderGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
          this.listData.map(function(item){
            //item.progress = []
            if(item.produceTasks){

              item.produceTasks.map(function(item1){
                var tem = item1
                if(item1.goodNum == '-'){
                  item1.goodNum = 0
                }
                if(item1.planNum == '-'){
                  item1.planNum = 0
                }
                if(item1.nongoodNum == '-'){
                  item1.nongoodNum = 0
                }
                if(item1.goodNum && item1.planNum){
                  // tem.process = item1.goodNum/item1.planNum
                  item1.process = ((item1.goodNum/item1.planNum) * 100).toFixed(2);
                }else{
                  // tem.process = 0
                  item1.process = 0;
                }
                // item.progress.push(tem)
              })
            }
          });
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error("2222" + err)
      })
    },
    getProcessTasks(){
      var data = {
        factoryId: this.userData.factoryId,
        onlyRun: this.onlyRun,
        time:this.tabPosition
      }
      getProcessTasks(data).then(res => {
        if(res.code == 200){
          this.kpi = res.data.kpi
          this.processTasks = res.data.processTasks
          if(this.processTasks && this.processTasks.length!=0){
            this.processTasks.map(function(item,index){
              item.color = this.colorArray[index%10]
              if(item.planNum && item.goodNum){
                item.progress = (item.planNum>0)?((item.goodNum/item.planNum) * 100).toFixed(2):0;
              }else{
                item.progress = 0
              }
            }.bind(this))
          }
        }else{
          this.$message.error( res.msg)
        }
      }).catch(err => {
        this.$message.error("1111" +err)
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata(this.form)
    },
    changeStatusColor(options){
      if(options == '逾'){
        return 'danger'
      }else if(options == '执行中'){
        return 'success'
      }else if(options == '已取消'){
        return 'warning'
      }else if(options == '已结束'){
        return 'info'
      }else{
        return ''
      }
    },
    changeClass(row){
      if(row.status == '执行中'){
        return 'small-blue-circle'
      }else if(row.status == '已结束'){
        return 'small-green-circle'
      }
    },
    showDialog(row){
      this.editRow = row
      this.dialogVisible = true
    },
    done(){
      this.dialogVisible = false
    },
    enterGetList(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        currentPage: this.pageNo,
        pageSize: this.pageSize,
      }
      enterGetList(params).then(res => {
        if(res.code == 200){
          this.activities = []
          let list = res.data.list
          for (let i = 0; i < list.length; i++) {
            this.activities.push(list[i]);
          }
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    handleDelete(row){
      this.$confirm('删除后，将同时删除关联的工单、任务和报工，且不可恢复。是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
          orderDelete(row._id).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
              // pageLoading.close();
          }).catch(err => {
            // pageLoading.close();
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    clickDropDown(options,row){
      if(options == '删除'){
        this.handleDelete(row)
      }else if(options == '结束' || options == '撤回' || options == '开始' ||options == '取消' ){
        var status = ''
        switch (options) {
          case '开始':
            status = '执行中'
            break;
          case '撤回':
              if(row.orderStatus == '执行中'){
                status = '未开始'
              }else if(row.orderStatus == '已结束'){
                status = '执行中'
              }
              break;
          case '结束':
            status = '已结束'
            break;
          case '取消':
            status = '已取消'
            break;
          default:
            break;
        }
        orderUpdateStatus(row.orderCode,options,status).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getdata()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }
    },
    filterStatus(options){
      this.orderStayus = options
      this.getdata()
    },
  }
}
</script>

<style scoped>
.home-main .header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #fff;
}
.header-right{
  display: flex;
  align-items: center;
}
.card-box{
  margin: 0px 16px 16px 0px;
  cursor: pointer;
  border: 0px;
  border-radius: 3px;
  background-color: rgb(250, 250, 250);
  overflow: hidden;
  color: rgba(0,0,0,.85);
  font-size: 12px;
  font-variant: tabular-nums;
  width: 250px;
  display: inline-block;
}
.card-box .card-body{
  padding: 0px;
  height: 120px;
  width: 250px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}
.card-body .card-body-left{
  border-right: 1px dashed rgb(239, 239, 239);
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
}
.card-body .card-body-right{
  display: flex;
  width: 100%;
  flex: 1 1 0%;
  flex-direction: column;
  justify-content: center;
  padding-top: 16px;
}
.card-body-header{
  position: absolute;
  height: 24px;
  width: 100%;
}
.card-body-header .header-left{
  padding-left: 8px;
  height: 22px;
  /* background-color: rgb(40, 194, 228); */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.card-body-header .header-right{
  width: 16px;
  height: 22px;
  border-radius: 0px 0px 100%;
  display: inline-block;
}
.card-body-left .body-left-top{
  font-size: 26px;
}
.card-body-left .body-left-bottom{
  color: rgb(153, 153, 153);
}
.card-body-right .body-right-common{
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.body-right-common .right-common-left{
  flex: 1 1 0%;
  text-align: right;
  color: rgb(153, 153, 153);
  margin-right: 6px;
}
.body-right-common .right-common-right{
  flex: 1 1 0%;
  text-align: left;
}
.body-right-common .right-one-right{
  color: rgb(0, 0, 0);
}
.body-right-common .right-two-right{
  color: rgb(2, 185, 128);
}
.body-right-common .right-three-right{
  color: rgb(250, 173, 20);
}
.progress-box{
  width: 100%;
  border-top: 1px solid rgb(242, 242, 242);
  text-align: center;
}
.progress-content{
  display: flex;
  width: 90%;
  margin: 6px 0 6px 6px;
  height: 100%;
  align-items: center;
}
.progress-content .title{
  width: 30px;
  color: rgb(153, 153, 153);
  font-size: 12px;
  margin-right: 5px;
}
.progress-content .progress{
  width: calc(100% - 30px);
}
.default-circle{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid rgb(204, 204, 204);
  }
  .blue-circle{
  border: 3px solid rgb(0, 120, 231);
  }
  .green-circle{
    color: #02b980;
    font-size: 35px;
    font-size: 21px;
    border: 3px solid rgb(2, 185, 128);
  }
  .default-percent-text{
    font-weight: 600;
    font-size: 10px;
    white-space: nowrap;
    vertical-align: middle;
    transform: scale(.83);
  }

  .default-process-item {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 36px;
    margin-right: 50px;
    margin-bottom: 20px;
}
.list-line-box {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 8px;
    overflow-y: hidden;
}
.default-process-text {
    position: absolute;
    left: 18px;
    max-width: 72px;
    margin-top: 2px;
    font-size: 12px;
    line-height: 12px;
    transform: translateX(-50%);
    bottom: -18px;
}
.process-text {
    width: 50px;
    text-align: center;
    overflow: hidden;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.default-delay-tag {
    position: absolute;
}
.delay-tag {
  top: -5px;
  right: -7px;
  margin-right: 2px;
  color: #fff;
  font-size: 10px;
  background-color: #ff393d;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  -webkit-transform: scale(.83);
  transform: scale(.83);
}
.el-divider{
  background-color: #575859;
}
.right-other{
  width: 300px;
  height: 100%;
  margin-left: 12px;
  box-shadow: rgb(0 0 0 / 6%) 2px 2px;
}
.home-table{
  width: calc(100% - 300px);
}
.small-cilcle{
  display: inline-block;
  background: rgb(232, 232, 232);
  margin-right: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.small-blue-circle{
 background: rgb(24, 145, 255);
}
.small-green-circle{
 background: rgb(2, 185, 128);;
}
.other-target-box{
  padding: 10px 10px 0;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.other-target{
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  padding: 5px 0;
  margin-bottom: 10px;
}
.other-target-value{
  font-size: 24px;
}
.other-target-label{
  font-size: 12px;
  opacity: .3;
}
.right-other .title{
  background: #fff;
  padding: 20px 0 10px 12px;
}
.step-box{
  height: 319px;
  background-color: rgb(255, 255, 255);
  overflow: scroll;
  padding: 15px;
}
.step-box .el-timeline{
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue